import React from 'react';
import { User } from '@/types';
import { useApplicationData } from './hooks/useApplicationData';
import { 
  ProfileStrength, 
  RequiredDocuments, 
  UpcomingDeadlines, 
  ApplicationProgress 
} from './components';
import './NewDashboard.css';

interface ApplicationHubProps {
  user: User;
}

const ApplicationHub: React.FC<ApplicationHubProps> = ({ user }) => {
  const {
    profileStrength,
    upcomingDeadlines,
    applicationProgress,
    requiredDocuments,
    isLoading,
    error
  } = useApplicationData();

  if (error) {
    return (
      <div className="new-dashboard">
        <div className="dashboard-container">
          <div className="error-state">
            <h2>Error loading dashboard</h2>
            <p>Please try refreshing the page or contact support if the problem persists.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="new-dashboard">
      <div className="dashboard-container">
        <div className="dashboard-grid">
          <div>
            <ProfileStrength user={user} profileStrength={profileStrength} />
            <RequiredDocuments documents={requiredDocuments} />
          </div>

          <div className="main-content-area">
            <UpcomingDeadlines deadlines={upcomingDeadlines} />
            <ApplicationProgress applications={applicationProgress} isLoading={isLoading} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationHub; 